"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const classnames_template_literals_1 = __importDefault(require("@netlify/classnames-template-literals"));
const Avatar_1 = __importDefault(require("components/design-system/Avatar"));
const SVGIcon_1 = __importDefault(require("components/shared/SVGIcon"));
const TooltipPortal_1 = __importDefault(require("components/shared/Tooltips/TooltipPortal"));
const SingleUserCN = ({ isDisabled, customClass }) => {
    return (0, classnames_template_literals_1.default)(`
    flex
    items-center
    ${isDisabled ? 'cursor-not-allowed' : 'cursor-pointer'}
    ${customClass && customClass}
  `);
};
const SingleUser = ({ userData, size = 24, onClick, customClass, customTextClass, removeIconCallback, avatarPosition, dataCy, isDisabled }) => {
    const [portalData, setPortalData] = (0, react_1.useState)({});
    const [isEllipsis, setIsEllipsis] = (0, react_1.useState)({});
    const [isTooltipShown, setIsTooltipShown] = (0, react_1.useState)(false);
    const setPortal = (e) => {
        if (isEllipsis) {
            setIsTooltipShown(true);
            setPortalData({
                name: userData.name,
                left: e.currentTarget.getBoundingClientRect().x + 'px',
                top: e.currentTarget.getBoundingClientRect().top - 36 + 'px'
            });
        }
    };
    const setIsEllipsisHandler = (ref) => {
        if (ref) {
            setIsEllipsis(ref?.offsetWidth < ref?.scrollWidth);
        }
    };
    return (react_1.default.createElement("div", { className: SingleUserCN({ isDisabled, customClass }), onClick: () => !isDisabled && onClick && onClick(), "data-cy": dataCy },
        react_1.default.createElement(TooltipPortal_1.default, { show: isTooltipShown, portalData: portalData, portalId: "shared-tooltip" }),
        react_1.default.createElement(Avatar_1.default, { size: size, customClass: "mr-[8px]", src: userData?.src || userData?.profilePicture, position: avatarPosition, tooltip: false, ...userData }),
        react_1.default.createElement("span", { className: `grow truncate ${customTextClass ? customTextClass : 'typography-paragraph text-n-900'}`, onMouseOver: setPortal, onMouseOut: () => setIsTooltipShown(false), ref: setIsEllipsisHandler }, userData.name),
        removeIconCallback && (react_1.default.createElement(SVGIcon_1.default, { size: 24, fillColor: "var(--n-600)", iconName: "icon-clear", customClass: "remove-icon", onClick: removeIconCallback }))));
};
exports.default = SingleUser;
